import {requestTossBilling} from "../api/billing/billing.api";
import {useSearchParams} from "react-router-dom";

/**
 * 토스 카드(빌링키) 등록 후 돌아오는 처리 전용 페이지. 화면은 없다.
 *
 * ## 🔴 복귀 경로 수정 (2026-08-21)
 *
 * 종전에는 이렇게 조립했다:
 *   `${window.location.origin}${window.location.pathname}/payments`
 *
 * 이 페이지의 `pathname` 은 항상 **`/payments/toss/billing`** 이므로 결과는
 * **`/payments/toss/billing/payments`** 가 된다 — 라우트에 없으므로 `<Route path="*">` 에 걸려
 * **NotFound 화면**이 떴다. 카드 등록이 성공해도 고객은 "찾을 수 없는 페이지"를 보게 된다.
 * 온보딩 마지막 단계('카드 등록하기')가 이 경로를 타므로 신규 고객이 그대로 겪는다.
 *
 * 경위: `8d669ce7`("카드 등록 redirect 수정", 2026-04-17)에서 `pathname` 이 끼어들었다.
 * → **`origin + '/payments'`** 로 고정한다.
 *
 * ## `returnPath` (2026-10-12)
 *
 * 가입 위저드 (4)→(5) 에서 카드를 등록하면 **(6) 결제 화면으로 돌아와야** 한다. 그래서
 * `/payments/toss/billing/wizard` 라우트가 이 컴포넌트를 `returnPath="/wizard?step=payment"` 로 쓴다.
 * 실패해도 같은 곳으로 보낸다 — 위저드 (6) 이 "카드 없음" 상태를 그리고 다시 등록을 안내한다.
 */
const CARD_LIST_PATH = "/payments";

const TossPaymentBilling = ({returnPath = CARD_LIST_PATH}) => {
    const [query] = useSearchParams()
    const customerKey = query.get("customerKey")
    const authKey = query.get("authKey")
    const code = query.get("code")
    const message = query.get("message")

    const goBack = () => {
        window.location.href = `${window.location.origin}${returnPath}`
    }

    if (code || message) {
        alert(`카드 등록 실패: ${code}\n사유: ${message}`)
        goBack()
    } else {
        requestTossBilling(customerKey, authKey).then(({data}) => {
            if (data === "fail") {
                alert("카드 등록에 실패했습니다. 잠시 후 다시 시도 해주세요.")
            }
            goBack()
        })
    }
}

export default TossPaymentBilling
